import createPage from "../../templates";
import DefaultFilterGridActions from '../../actions/filter-grid'

const createAvanzamentiFilter = ({ filterPath }) => createPage({
    formName: 'avanzamenti',
    tabs: [
        {
            main: true,
            id: 'filter',
            template: 'filter-grid',        
            functionName: 'avanzamenti',
            gridFunctionName: 'avanzamenti',
            filterEndpoint: '/avanzamenti/filter',
            deleteEndpoint: '/avanzamenti/{{idnrr}}'
        }
    ],
    actions: DefaultFilterGridActions({
        createPath: filterPath + '/0', //'/avanzamento-casi/0',
        createInitialData: { 
            idnrr: 0
        },
        deleteEndpoint: '/avanzamenti/{{idnrr}}',
        exportEndpoint: '/avanzamenti/export'
    })
})

export default createAvanzamentiFilter